export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13847.6b195416.jpg";